import React from 'react'

import TextDraft from 'lemon-campaign-ui/lib/molecules/TextDraft'
import Text from 'lemon-campaign-ui/lib/molecules/Text'

export default ({ component, defaults }) => {
  let element

  if (component.content.wysiwyg) {
    element = (
      <TextDraft
        {...defaults}
        draft={component.content.wysiwyg}
        align={component.content.align}
        color={component.content.color}
      />
    )
  } else {
    element = (
      <Text
        {...defaults}
        size={component.content.size}
        link={component.content.link}
        align={component.content.align}
        color={component.content.color}
      >
        {component.content.text}
      </Text>
    )
  }

  return element
}
